import { memo, type MouseEvent } from "react";

import { Button } from "@components/Button";
import { tw } from "classnames";

type Props = {
  adjacentCollection: {
    handle: string;
    id: string;
    title: string;
  };
  handleAdjacentCollectionButtonClick: (
    event: MouseEvent<HTMLAnchorElement>
  ) => void;
  href: string;
  isActive: boolean;
};

const styles = {
  base: tw("shrink-0"),
};

const CollectionAdjacentCollectionButtonViewBase = ({
  adjacentCollection,
  handleAdjacentCollectionButtonClick,
  href,
  isActive,
}: Props) => {
  return (
    <Button
      aria-current={isActive ? "page" : undefined}
      as="link"
      className={styles.base}
      key={adjacentCollection.id}
      onClick={handleAdjacentCollectionButtonClick}
      size="small"
      to={href}
      type={isActive ? "quaternary-alt" : "quaternary"}
    >
      {adjacentCollection.title}
    </Button>
  );
};

export const CollectionAdjacentCollectionButtonView = memo(
  CollectionAdjacentCollectionButtonViewBase
);
